import { Outlet } from 'react-router-dom';
import { ExpandedHeader } from '../../../shared/components/expanded-header/expanded-header';
import { Footer } from '../../../shared/components/footer/footer';

const WelcomeWrapper = () => {
	return (
		<div>
			<div className='w-full'>
				<ExpandedHeader></ExpandedHeader>
			</div>
            <div className='w-full'>
                <Outlet></Outlet>
            </div>
            <div className='w-full bottom-[0]'>
            <Footer></Footer>
            </div>
		</div>
	);
};
export default WelcomeWrapper;
